import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
// Import Shared Components
import { Modal, ActionBar, ButtonGroup, Loader } from 'shared-components';
// Import Global Components
import Heading from '../Heading';
import Button from '../Button';
import CancelButton from '../CancelButton';
import Alert from '../Alert';
// Import Global Layouts
import { ModalFormContainer } from '../../layouts/Form';
// Import Hooks
import { PIN_UNBLOCK_STATES } from '../../hooks/usePinUnblock';
// Import Component Styles
import { Effects, Paragraph } from './styles';
import useSupportContact from './useSupportContact';

const bold = chunks => <b>{chunks}</b>;

const EFFECTS = [1, 2, 3, 4];

// State C: says what unlocking does and does not do before anything happens.
const UnblockPinModal = ({ state, submitting, failed, onConfirm, onCancel }) => {
  const support = useSupportContact();
  const intl = useIntl();

  if (state !== PIN_UNBLOCK_STATES.CONFIRMING) return null;

  return (
    <Modal>
      <ModalFormContainer>
        {failed && (
          <Alert
            alert={intl.messages['unlock-pin-failed-alert']}
            alertFor="unlock-pin-failed"
            values={{ support }}
            type="danger"
          />
        )}
        <Heading page="unlock-pin" heading={intl.messages['unlock-pin-heading']} />
        {submitting ? (
          <Loader />
        ) : (
          <>
            <Paragraph>
              <FormattedMessage id="unlock-pin-intro" />
            </Paragraph>
            <Paragraph>
              <FormattedMessage id="unlock-pin-lead" />
            </Paragraph>
            <Effects>
              {EFFECTS.map(n => (
                <li key={n}>
                  <FormattedMessage id={`unlock-pin-effect-${n}`} values={{ b: bold }} />
                </li>
              ))}
            </Effects>
            <ActionBar>
              <ButtonGroup reverse>
                <Button
                  buttonText={intl.messages['unlock-pin-confirm-button']}
                  page="unlock-pin"
                  buttonFor="confirm"
                  type="primary"
                  size="large"
                  onClick={onConfirm}
                />
                <CancelButton onClick={onCancel} type="neutral" />
              </ButtonGroup>
            </ActionBar>
          </>
        )}
      </ModalFormContainer>
    </Modal>
  );
};

UnblockPinModal.propTypes = {
  state: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  failed: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default UnblockPinModal;
